import { render, staticRenderFns } from "./SpaceStatistic.vue?vue&type=template&id=e34a522e&scoped=true"
import script from "./SpaceStatistic.vue?vue&type=script&lang=ts"
export * from "./SpaceStatistic.vue?vue&type=script&lang=ts"
import style0 from "./SpaceStatistic.vue?vue&type=style&index=0&id=e34a522e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34a522e",
  null
  
)

export default component.exports